import config from '../../data/config';

const ko = {
    Home:{
        title: '세상을 향한 개인 포탈 사이트',
        subtitle: '자신의 북마크를 모아 만드는, 세상을 향한 개인 포탈 사이트',
        purpose: '이 사이트는 뭔가?',
        purpose1: '북마클릿을 이용해서 자신의 북마크를 수집하여, 세상을 향한, 자신만의 포탈 사이트를 만듭니다.',
        purpose2: '북마크를 생성, 편집, 삭제합니다. 멋진 배경도 설정할 수 있습니다.',
        purpose3: '드래그-드롭으로 북마크를 재배치할 수있습니다.',
        purpose4: '여러 페이지를 생성하고 페이지별로 공개, 비공개 ( 기본 )를 설정할 수있습니다',
        purpose5: '좋은 북마크를 다른이들과 공유할 수있습니다',
        purpose6: '등록하지않으면 \'anonym\' 사용자 아이디를 사용할수있습니다. 등록하면(무료) 자신의 사용자 아이디를 사용할 수있습니다',
        purpose7: '모든 서비스는 무료입니다.',
        contact: '연락처',
        signup: '무료 등록',
        contactName: '네오홈피',
        contactEmail: 'neohompy@gmail.com',
        card1:{
            image: '/img/1-300x200.jpg',
            title: '사용자 아이디 \'anonym\'',
            descr1: '등록하지않으면 위 아이디를 사용할 수있습니다',
            descr2: '이 경우, 모든 북마크는 자신의 컴퓨터에 저장됩니다.',
            descr3: '다른 기기에서, 자신의 북마크를 공유하고싶으면 등록하면 됩니다. 무료입니다',
            more: '더 알아보기!',
            moreUrl: '',
        },
        card2:{
            image: '/img/2-300x200.jpg',
            title: '자신의 사용자 아이디',
            descr1: '등록하면 자신의 사용자 아이디를 가질 수있습니다',
            descr2: '이 경우, 자신의 북마크는 서버에 저장됩니다. 공개, 비공개(기본)를 설정할 수있습니다.',
            descr3: '자신의 다른 기기에서 북마크를 공유할 수있습니다. 모두 무료입니다.',
            more: '더 알아보기!',
            moreUrl: '',
        },
        card3:{
            image: '/img/3-300x200.jpg',
            title: '북마클릿',
            descr1: '북마클릿을 사용하여 북마크를 수집합니다.',
            descr2: '북마클릿은 홈페이지 헤더에 있습니다.',
            descr3: '북마클릿을 드래그드롭하여 자신의 웹브라우저의 북마크바에 옮겨놓으세요.',
            more: '더 알아보기!',
            moreUrl: '',
        },
        card4:{
            image: '/img/4-300x200.jpg',
            title: '기존 북마크 가져오기',
            descr1: '자신의 웹브라우저에서 사용하던 북마크를 가져올 수있습니다.',
            descr2: '먼저, 자신의 웹브라우저에 있는 북마크를 HTML 파일 형식으로 내보냅니다.',
            descr3: '다음, 그 북마크 파일을 새 페이지로 불러들입니다.',
            more: '더 알아보기!',
            moreUrl: '',
        },
        card5:{
            image: '/img/5-300x200.jpg',
            title: '드래그 앤 드롭',
            descr1: '페이지에 있는 카테고리, 북, 북마크(링크)의 제목을 드래그 앤 드롭 할수있습니다.',
            descr2: '아이템의 제목을 드래그하여 타겟의 제목에 드롭하면, 그 타겟의 자식 (또는 형제)이 됩니다.',
            descr3: '아이템의 제목을 드래그하여 타겟의 아이콘에 드롭하면, 그 타겟의 형제 (또는 자식)가 됩니다.',
            more: '더 알아보기!',
            moreUrl: '',
        },
        card6:{
            image: '/img/6-300x200.jpg',
            title: '공개, 비공개 페이지',
            descr1: '페이지의 공개 , 비공개 (기본) 여부를 설정할 수있습니다.',
            descr2: '비공개 설정시, 다른이들은 그 페이지에 접근할 수없습니다.',
            descr3: '북 별로 공개여부를 설정하여 다른이와 공유할 수있습니다.',
            more: '더 알아보기!',
            moreUrl: '',
        },
    },
    share:{
        mainTitle: '좋은 북마크 책들을 공유하세요.',
        humanSelected: '이들 북마크 책들은, 사람들이 선택하고 관리하는 것들입니다.',
        embedInto: '각 북마크 책들을, 당신의 페이지로 복사하거나 당신의 웹사이트에 삽입할 수있습니다.',
        url1: '책 주소는 https://neohompy.com/share/BookTitle',
        example1: '예: ',
        exampleUrl1: 'https://neohompy.com/share/izone',
        url2: '또는 책 주소는 https://neohompy.com/share/SearchWord',
        example2: '예: ',
        exampleUrl2: 'https://neohompy.com/share/k-pop',
        embedCode: '임베드 코드는 아래와 같습니다 :',
        recentBooks: '최신 책들',
        moreRecentBooks: '더보기',
        end: '끝',
        searchResult: '검색 결과',
        moreSearchResult: '더보기',
    },
    Footer:{
        copyright: '저작권',
        company: '네오홈피 2020',
    },
    header:{
        name: '한국어',
        company: '네오홈피',
        home: '홈',
        share: '공유',
        myhome: '마이홈',
        signup: '등록',
        signout: '탈퇴',
        login: '로그인',
        logout: '로그아웃',
        account: '계정',
        bookmarklet: '북마클릿',
    },
    PageList:{
        newpage: '+ 새 페이지',
       public: '공개',
       private: '비공개',
    },
    page:{
        public: '공개',
        private: '미공개',
        pge: '페이지',
        auth_error: '편집권한이 없습니다.',
        moveItemError: '부모 아이템은 자식 아이템으로 이동못합니다.',
        moveItemChildError: '부모 아이템은 자식아이템 아래로 이동못합니다.',
    },
    HeaderMyhome:{
        memoShown: '보임',
        memoHidden: '숨김',
        tidy1: '원래',
        tidy2: '정렬',
        tidy3: '배경',
        bookmarklet: '북마클릿',
    },
    Search: {
        searchHolder: '검색',
        search: '검색',
    },
    SearchResult: {
         SearchResults: '검색 결과',
        NoSearchResults: '검색 없음',
    },
    loginmodal:{
        login: '로그인',
        signup: '등록',
        email: '이메일',
        emailholder: '이메일 입력',
        emailguide: 'example@example.com',
        requestcode_label: '이메일 확인',
        requestcode: '확인코드 요청',
        requestcode_guide: '',
        verifycode_holder: '확인코드 입력',
        verifycode: '코드 전송',
        notverified_error: '이메일이 확인되지 않았습니다',
        userid: '아이디',
        useridholder: '아이디 입력',
        useridguide: config.userid_min + '-' + config.userid_max + ' 길이의 문자와 숫자.',
        userid_lower_error: '모두 소문자이어야합니다.',
        userid_min_error: config.userid_min + ' 보다 길어야합니다.',
        userid_max_error: config.userid_max + ' 보다 짧아야합니다.',
        userid_required_error: '아이디가 필요합니다',
        pass: '암호',
        passholder: '암호 입력',
        passguide: config.pass_min + '-' + config.pass_max + ' 길이의 문자와 숫자.',
        pass_min_error: config.pass_min + ' 보다 길어야합니다.',
        pass_max_error: config.pass_max + ' 보다 짧아야합니다.',
        pass2: '암호2',
        passholder2: '같은 암호 입력',
        passguide2: '같은 암호를 입력해주세요.',
        pass_match_error: '두 암호가 같지않습니다.',
        close: '닫기',
        submit: '보내기',
        title_min_error:'제목이 짧습니다.',
        title_max_error:'제목이 깁니다.',
        title_required_error: '제목이 필요합니다.',
        url_error:'Url 형식이 틀립니다.',
        url_max_error:'Url 이 깁니다.',
        bgurl_max_error:'Url 이 짧습니다.',
        email_error:'이메일 형식이 틀립니다.',
        email_max_error:'이메일이 깁니다.',
        email_required_error:'이메일이 필요합니다',
        pass_mismatch_error:'확인암호가 같지않습니다.',
        pass_required_error:'암호가 필요합니다.',
        token_error: '토큰이 틀립니다.',
        token_min_error:'토큰이 짧습니다.',
        token_max_error:'토큰이 깁니다.',
        pass_change_msg: '암호가 바뀌었습니다.',
        pass_change_error: '암호바꾸기에 문제가 있습니다.',
        pass_wrong_error: '아이디 또는 암호가 틀립니다.',
        server_error: '서버에 문제가 있습니다.',
        unique_error: '아이디가 존재합니다.',

    },
    logoutmodal:{
        logout: '로그아웃',
        logoutConfirm: '로그아웃하시겠습니까? 언제든 다시 오세요.',
        logoutBtn: '확인',
        closeBtn: '취소',
        signout: '탈퇴',
        signoutConfirm: '탈퇴하시겠습니까? 모든 데이타가 사라집니다.',
        signoutBtn: '확인',
        signoutTab: '탈퇴',
        newpassTab: '암호바꾸기',
        newpassTitle: '암호바꾸기',
        userid: '아이디',
        useridguide: '현재 아이디',
        pass: '암호',
        passguide: '현재 암호',
        newpass: '새 암호',
        newpassholder: '새 암호를 입력하세요',
        newpassConfirm: '암호를 바꾸기위해, 현재 암호와 새 암호를 입력하세요',
        newpassguide: config.pass_min + '-' + config.pass_max + ' 길이의 문자와 숫자.',
        newpassBtn: '확인',
    },
    mymodal:{
        type:{
            pge: '페이지',
            fld: '분류',
            bok: '책',
            lnk: '링크'
        },
        edt:{
            title: '편집',
            tab: '편집'
        },
        fld:{
            title: '새 분류',
            tab: '분류'
        },
        bok:{
            title: '새 책',
            tab: '책'
        },
        lnk:{
            title: '새 링크',
            tab: '링크'
        },
        pge: {
            title: '새 페이지',
            tab: '페이지'
        },
        form:{
            kind: '종류',
            child: '자식',
            sibling: '형제',
            sharing: '공유여부',
            share: '공유',
            notshare: '비공유',
            privacy: '공개여부',
            public: '공개',
            private: '비공개',
            defaulting: '기본여부',
            default: '기본',
            notdefault: '기본 아님',
            title: '제목',
            titleHolder: '제목 입력',
            href: 'URL',
            hrefHolder: 'URL 입력 (선택)',
            bgurl: '배경 URL',
            bgurlHolder: '배경 URL 입력 (선택)',
            memo: '메모',
            memoHolder: '메모 입력 (선택)',
            keywords: '키워드',
            keywordsHolder: '키워드 입력 (선택)',
            smallBg: '작은 그림',
            smallBgHolder: '작은 그림 URL 입력',
            largeBg: '큰 그림',
            largeBgHolder: '큰 그림 URL 입력',
            bgColor: '배경색',
            bgColorHolder: '배경색 입력',
            color: '글자색',
            colorHolder: '글자색 입력',
            icon: '아이콘 URL',
            iconHolder: '아이콘 URL 입력',
            title_min_error: '제목이 너무 짧음',
            title_max_error: '제목이 너무 긺',
            unique_error: '제목이 중복됨',
            url_error: 'url 틀림',
            url_max_error: 'url 너무 긺',
            memo_min_error: '메모가 너무 짧음',
            memo_max_error: '메모가 너무 긺',
            bgurl_max_error: 'bgurl 너무 긺',
        },
        share: '공유',
        unshare: '비공유',
        shared: '공유 아이템',
        unshared: '비공유 아이템',
        confirmshare: '이 아이템을 공유하시겠습니까?',
        confirmunshare: '이 아이템을 비공유하시겠습니까?',
        saveCloseState: '상태 보관',
        copy: '베낌',
        cut: '자름',
        paste: '붙임',
        close: '닫음',
        submit: '저장',
        delete: '삭제',
        quickdelete: '삭제',
        create_error: '링크에 카테고리나 북을 생성할 수없습니다',
        paste_error: '링크에 카테고리나 북을 붙일 수없습니다.',
        auth_error: '편집권한이 없습니다.',
        pageCopy_error: '페이지는 복사할 수없습니다',
        pageCut_error: '페이지는 자를 수없습니다',
        clearpaste: '붙이기 취소',
        clearnewlink: '링크 취소',
        setAsDefault: '기본 페이지로 설정',
        isDefault: '기본 페이지',
    },
    mymodalshare:{
        copyquestion:'복사하시겠습니까?',
        type:{
         pge: '페이지',
         fld:'분류',
         bok: '책',
         lnk: '링크'
        },
        copy: '복사',
        copyguide: '복사한 아이템을 붙이거나 취소하세요',
        cancelcopy: '복사 취소',
        close: '닫기',
        cannotcopy: '페이지는 복사할 수없습니다.',
        copywidget: '이 코드를 복사한 후, 당신의 HTML 페이지에 붙여넣으세요.',
       copyurl: '다른 검색어를 원한다면, "YourWord"를 당신의 검색어로 치환하거나, 새로운 검색을 하세요.',
       companyurl: 'https://neohompy.com/share',
       companyname: '네오홈피',

    },
    expo:{
        tabImport: '가져오기',
        tabExport: '내보내기',
        tabRecover: '복구',
        tabClear: '삭제',
        tabTheme: '테마',
        tabBgimg: '배경',
        tabTools: '도구',
        title:{
           tabImport: '북마크 가져오기 (HTML 또는 JSON)',
           tabExport: '북마크 내보내기',
           tabRecover: '기본 북마크 복구',
           tabClear: '로컬 저장 삭제',
           tabTheme: '테마',
           tabBgimg: '배경 그림',
           tabTools: '도구들',
        },
        bodyImport: {
            html: '가져올 북마크 html 파일 선택',
            json: '가져올 북마크 JSON 파일 선택 (추천)',
            default: '기본 페이지 가져오기',
            defaultBtn: '기본 페이지',
        },
        bodyExport: {
            body1: '북마크 파일을 html 이나 json 파일로 내려받기.',
            body2: '다른 웹브라우저로 가져가려면 HTML 파일을 선택하세요.',
            btn1: 'HTML 파일로 내려받기',
            btn2: 'JSON 파일로 내려받기 (추천)',
        },
        bodyRecover: {
            body1: '북마크를 서버에 저장하기 위해, 임시 아이디와 암호를 사용합니다.',
            userid: '아이디',
            useridHolder: '아이디를 입력...',
            password: '암호',
            passwordHolder: '암호를 입력...',
            btn1: '서버로 내보내기',
            btn2: '서버로부터 가져오기',
            foot1: '현재의 북마크는 서버의 북마크나 기본 북마크로 대체됩니다.',
        },
        bodyClear: {
            body1:'로컬 저장소를 지우기.',
            body2:' 모든 북마크가 로컬 저장소에서 지워집니다.',
            body3:'따라서 다음에 주의하세요, ',
            body4:' 현재의 북마크를 html 파일로 저장해두세요, ',
            body5:' 저장소를 지우기 전에.',
            body6:'저장소가 지워지면 기본 북마크로 돌아갑니다.',
            btn1:'로컬 저장소 지우기',
        },
        bodyTheme: {
            body1: '테마. 기본 테마는 \'cosmo\' 입니다.',
            dropdown1: '테마 선택',
        },
        bodyBgImage: {
            body1: '배경 그림.',
            dropdown1: '배경 그림 선택',
        },
        bodyTools: {
            body1: '북마크에 다음 처리가 실행됩니다.',
            body2: '하고싶은 처리를 선택하세요.',
            body3: '처리 결과는 ',
            body4: '저장 단추를 누르기 전까지',
            body5: ' 저장되지않습니다.',
            body6: '최초 갯수: ',
            body7: ' 최종 갯수: ',
            body8: ' 처리 갯수: ',
            btn1: '중복 북마크 없애기',
            btn2: '빈 폴더 없애기',
            btn3: '폴더 정렬',
            btn4: '폴더 정렬 (역순)',
            btn5: '정렬 복구',
            btn6: '카테고리 단순화',
        },
        footBtn1: '기본 북마크 가져오기',
        footBtn2: '닫기',
        footBtn3: '테마 저장',
        footBtn4: '배경 그림 저장',
        footBtn5: '처리 결과 저장',
        mockPageData: {
            type: "pge",
            key: "홈",
            title: "홈",
            close: false,
            default: false,
            children: [
              {
                children: [
                  {
                    type: "bok",
                    key: "5z7F5TIaH2",
                    title: "임시",
                  },
                ],
                type: "fld",
                key: "5z7F5TIaH3",
                title: "임시",
              },
              {
                children: [
                  {
                    type: "bok",
                    key: "d9RyT4vpy4",
                    title: "일과",
                  },
                  {
                    type: "bok",
                    key: "d9RyT4vpy1",
                    title: "이메일",
                  },
                  {
                    type: "bok",
                    key: "d9RyT4vpy3",
                    title: "검색",
                  },
                ],
                type: "fld",
                key: "d9RyT4vpy0",
                title: "일과",
              },
              {
                children: [
                  {
                    type: "bok",
                    key: "dyGdiLYg32",
                    title: "뉴스",
                  },
                  {
                    type: "bok",
                    key: "kgae9aqCc0",
                    title: "과학",
                  },
                ],
                type: "fld",
                key: "d9RyT4vpy6",
                title: "뉴스",
              },
              {
                children: [
                  {
                    type: "bok",
                    key: "Xju6PbN7o1",
                    title: "사회",
                  },
                ],
                type: "fld",
                key: "d9RyT4vpy8",
                title: "사회",
              },
              {
                children: [
                  {
                    type: "bok",
                    key: "pU12o0gLg5",
                    title: "장보기",
                  },
                ],
                type: "fld",
                key: "pU12o0gLg4",
                title: "장보기",
              },
              {
                children: [
                  {
                    type: "bok",
                    key: "5z7F5TIaH1",
                    title: "사업",
                  },
                  {
                    type: "bok",
                    key: "kgae9aqCc4",
                    title: "부동산",
                  },
                  {
                    type: "bok",
                    key: "kgae9aqCc3",
                    title: "재정",
                  },
                ],
                type: "fld",
                key: "kgae9aqCc2",
                title: "사업",
              },
              {
                children: [
                  {
                    type: "bok",
                    key: "dyGdiLYg35",
                    title: "게임",
                  },
                  {
                    type: "bok",
                    key: "dyGdiLYg34",
                    title: "비디오",
                  },
                  {
                    type: "bok",
                    key: "dyGdiLYg33",
                    title: "음악",
                  },
                ],
                type: "fld",
                key: "d9RyT4vpy7",
                title: "오락",
              },
              {
                children: [
                  {
                    type: "bok",
                    key: "iLSYvK3DA0",
                    title: "생활",
                  },
                  {
                    type: "bok",
                    key: "RR8SEXtEw0",
                    title: "음식",
                  },
                  {
                    type: "bok",
                    key: "Xju6PbN7o0",
                    title: "건강",
                  },
                ],
                type: "fld",
                key: "JGfJ_gc3L0",
                title: "생활",
              },
              {
                children: [
                  {
                    type: "bok",
                    key: "pU12o0gLg1",
                    title: "취미",
                  },
                  {
                    type: "bok",
                    key: "pU12o0gLg3",
                    title: "예술",
                  },
                  {
                    type: "bok",
                    key: "pU12o0gLg2",
                    title: "여행",
                  },
                ],
                type: "fld",
                key: "rkmMsW9V10",
                title: "취미",
              },
            ],
          },
        mockPageList: [
        {
            type: "pge",
            key: "홈",
            title: "홈",
        },
        ],
        shortPageData: {
            "type": "pge",
            "key": "홈",
            "title": "홈",
            "close": false,
            "default": false,
            "children": [
                {
                "children": [
                    {
                    "type": "bok",
                    "key": "d9RyT4vpy4",
                    "title": "책",
                    "children": [
                        {
                        "children": [
                            {
                            "type": "lnk",
                            "key": "I4FxYgS3056",
                            "title": "링크"
                            }
                        ],
                        "type": "lnk",
                        "key": "I4FxYgS3034",
                        "title": "링크"
                        }
                    ],
                    }
                ],
                "type": "fld",
                "key": "d9RyT4vpy0",
                "title": "분류"
                }
            ]
        }        
    },    
}

export default ko;